import { Modal, Form, Select } from "antd";
import { FormInstance } from "antd/es/form";

import { IProjectTeamMember } from "../types";

import { UK_REGIONS } from "@/constants/region";

interface MemberFormModalProps {
  isOpen: boolean;
  editingMember: IProjectTeamMember | null;
  form: FormInstance;
  confirmLoading: boolean;
  availableRoles?: string[];
  availableUsers: { email: string; fullName: string }[];
  availableProjects: { value: string; label: string }[];
  projectsLoading: boolean;
  onOk: () => void;
  onCancel: () => void;
}

const MemberFormModal = ({
  isOpen,
  editingMember,
  form,
  confirmLoading,
  availableRoles,
  availableUsers,
  availableProjects,
  projectsLoading,
  onOk,
  onCancel
}: MemberFormModalProps) => (
  <Modal
    title={editingMember ? "Edit Team Member" : "Add Team Member"}
    open={isOpen}
    onOk={onOk}
    onCancel={onCancel}
    confirmLoading={confirmLoading}
  >
    <Form form={form} layout="vertical">
      <Form.Item
        name="role"
        label="Role"
        rules={[{ required: true, message: "Please select a role" }]}
      >
        <Select
          placeholder="Select a role"
          showSearch
          optionFilterProp="label"
          options={availableRoles?.map((role) => ({
            value: role,
            label: role
          }))}
          onSelect={() => {
            if (!editingMember) {
              form.resetFields(["email"]);
            }
            form.setFieldsValue({ project: null });
          }}
        />
      </Form.Item>

      <Form.Item
        name="email"
        label="User"
        rules={[{ required: true, message: "Please select a user" }]}
      >
        <Select
          placeholder="Select a user"
          disabled={!!editingMember}
          showSearch
          optionFilterProp="label"
          options={availableUsers.map((user) => ({
            value: user.email,
            label: user.fullName
          }))}
        />
      </Form.Item>

      <Form.Item
        name="region"
        label="Region"
        rules={[{ required: true, message: "Please select a region" }]}
      >
        <Select
          placeholder="Select a region"
          showSearch
          optionFilterProp="label"
          onChange={() => form.setFieldsValue({ project: null })}
          options={UK_REGIONS.map((region) => ({
            value: region,
            label: region
          }))}
        />
      </Form.Item>

      <Form.Item
        name="project"
        label="Project"
        dependencies={["role"]}
        rules={[
          ({ getFieldValue }) => ({
            validator(_, value) {
              const selectedRole = getFieldValue("role");

              if (selectedRole === "Site Manager/Supervisor" && !value) {
                return Promise.reject(new Error("Please select a project"));
              }

              return Promise.resolve();
            }
          })
        ]}
      >
        <Select
          showSearch
          allowClear
          placeholder="Select a project"
          optionFilterProp="label"
          loading={projectsLoading}
          options={availableProjects}
        />
      </Form.Item>
    </Form>
  </Modal>
);

export default MemberFormModal;
